<mat-card>{{'cardsOrders' | translate}}</mat-card>

<div class="container" style="padding: 25px;">

    <mat-grid-list cols="4" rowHeight="50px">
        <mat-grid-tile cols="2">
            <mat-form-field appearance="fill" class="example-form-field">
                <mat-label>{{'enterDateRange' | translate}}</mat-label>
                <mat-date-range-input [rangePicker]="rangePicker">
                    <input matStartDate placeholder="Start date" #fromDate>
                    <input matEndDate placeholder="End date" #toDate>
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #rangePicker>
                    <mat-date-range-picker-actions>
                        <button mat-button matDateRangePickerCancel>{{'cancel' | translate}}</button>
                        <button mat-raised-button color="primary" (click)="onApply()" matDateRangePickerApply>{{'filter'
                            |
                            translate}}</button>
                    </mat-date-range-picker-actions>
                </mat-date-range-picker>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>

            <button mat-raised-button color="primary" (click)="onApply()" style="margin-left: 10px;">
                <mat-icon>search</mat-icon>
                {{'filter' | translate}}
            </button>
            <button mat-raised-button color="primary" [disabled]="reports.length == 0" (click)="Print()">
                <mat-icon>print</mat-icon>
                {{'print' | translate}}
            </button>

        </mat-grid-tile>
        <mat-grid-tile></mat-grid-tile>


    </mat-grid-list>

    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort id="ordersTable">

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'dateTime' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.date }} </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="userFullName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'name' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.userFullName}} </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="service">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'service' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{
                    row.serviceClass == 1 && row.serviceNo == 1 ? 'خدمات حكومية - حسن سيرة' :
                    row.serviceClass == 1 && row.serviceNo == 2 ? 'خدمات حكومية - عدم محكومية' :
                    row.serviceClass == 1 && row.serviceNo == 3 ? 'خدمات حكومية - مكرمة' :
                    row.serviceClass == 1 && row.serviceNo == 4 ? 'خدمات حكومية - مكرمة جيش' :
                    row.serviceClass == 1 && row.serviceNo == 5 ? 'خدمات حكومية - قبول موحد' :
                    row.serviceClass == 1 && row.serviceNo == 6 ? 'دفع رسوم جامعة' :
                    row.serviceClass == 2 && row.serviceNo == 1 ? 'دفع فواتير كهرباء' :
                    row.serviceClass == 2 && row.serviceNo == 2 ? 'دفع فواتير مياه' :
                    row.serviceClass == 2 && row.serviceNo == 3 ? 'دفع فواتير اتصالات' :
                    ' تحويل محافظ'

                    }} </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="referenceNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'CardRefNo' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.referenceNumber}} </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="companyName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'companyName' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.companyName}} </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="serviceType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'serviceType' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.serviceType}} </td>
                <td mat-footer-cell *matFooterCellDef>{{'total' | translate}}</td>
            </ng-container>

            <ng-container matColumnDef="paymentValue">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'amount' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.paymentValue}} </td>

                <td mat-footer-cell *matFooterCellDef> {{getTotalCost()}} </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'status' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    {{
                    row.status == 0 ? ('onRequest' | translate) :
                    row.status == 1 ? ('onProccess' | translate) :
                    row.status == 2 ? ('orderDone' | translate) :
                    ('rejected' | translate)
                    }} </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}}"</td>
            </tr>
        </table>

        <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

</div>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>